import {
    bannerImage1, teamImage1, teamImage2, teamImage3,
    Facebook,
    XIcon,
    Instagram,
    LocationOn, Email, Phone,
    serviceImage1,
    serviceImage2,
    serviceImage3,
    teamImage4
} from "./images"
import { COLORS } from "./COLORS";
// about heading Text
export const aboutHeading = "About Us";
export const aboutSubHeading = "  Experience and Expertise: Our Financial Consulting Team";
// contact heading Text
export const contactHeadingText = "Get in Touch";
export const contactSubHeadingText = "We are here for you! How can we help?"
//team heading text
export const teamHeadingText = "OUR TEAM";
export const teamSubHeadingText = "Leading the way in business transformation"
//service heading text
export const serviceHeadingText = " OUR SERVICES";
export const serviceSubHeadingText = "Innovate to dominate with us";

//button Text
export const contactButtonText = "Submit";
export const footerButtonText = "Send";


//navigation bar Data
export const navigationData = ["Home", "About", "Service", "Team", "Contact"];

//banner data
export const bannerImages = [bannerImage1];
export const bannerData = [
    "Be Invest",
    "Our Mission Is Your Financial Status",
    "And in order to make a business, brand advertising and marketing plays an important role. Similarly, in making cultivation business a brand."
];
//service data
export const servicesData = [
    {
        title: "Velocity Solutions",
        description: "Hear what our customers have to say about us! We helped thousands.",
        image: serviceImage1,
    },
    {
        title: "Revive Business",
        description: "Hear what our customers have to say about us! We helped thousands.",
        image: serviceImage2,
    },
    {
        title: "Propel Consulting",
        description: "Hear what our customers have to say about us! We helped thousands.",
        image: serviceImage3,
    },
];

//about data
export const aboutData = {
    title: "ABOUT US",
    subtitle: "Solutions that make a difference",
    description: `Payment solutions enable businesses to accept payments securely and efficiently. Our services provide seamless integration to manage transactions with ease.`,
    bulletPoints: [
        "Mistakes To Avoid in Business",
        "Your Startup Industry Standards",
        " Avoid Common Mistakes",
        "  Our Startup Industry Insights"
    ],
    buttonText: "CONTACT US"
};

// team data
export const teamMembers = [
    {
        id: 1,
        name: "Alice Johnson",
        role: "Frontend Developer",
        image: teamImage1,
        phoneNumber: "+972-526980001"
    },
    {
        id: 2,
        name: "Bob Williams",
        role: "Backend Developer",
        image: teamImage2,
        phoneNumber: "+972-526980002"
    },
    {
        id: 3,
        name: "Charlie Brown",
        role: "UI/UX Designer",
        image: teamImage3,
        phoneNumber: "+972-526980003"
    },
    {
        id: 4,
        name: "Daisy Smith",
        role: "Project Manager",
        image: teamImage4,
        phoneNumber: "+972-526980004"
    },

];
//footer data
export const mediaData = [
    { Icon: Facebook, link: "https://www.facebook.com" },
    { Icon: XIcon, link: "https://www.twitter.com" },
    { Icon: Instagram, link: "https://www.instagram.com" },
];

// contact form data
export const contactDetails = [
    {
        icon: <LocationOn color={COLORS.secondaryColor} />,
        title: "Address",
        detail: "2118, Syracuse, Connecticut 35624"
    },
    {
        icon: <Email color={COLORS.secondaryColor} />,
        title: "Mail Us",
        detail: "tanya.hill@example.com"
    },
    {
        icon: <Phone color={COLORS.secondaryColor} />,
        title: "Telephone",
        detail: "(704) 555-0127"
    }
];
// contact form fields
export const formFields = [
    { id: "name", label: "Name", type: "text", placeholder: "Your Name" },
    { id: "email", label: "Email", type: "email", placeholder: "Your Email" },
    {
        id: "phone",
        label: "Phone Number",
        type: "tel",
        placeholder: "Enter your phone number",
    },
    { id: "message", label: "Message", type: "text", placeholder: "Your Message", multiline: true, rows: 4 }
];



export const googleMapLink = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.473830707999!2d28.041218800000003!3d-26.1486937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e9573c1da706ef5%3A0x9202607f9dc6f18!2sBig%20Five%20CRM%20Technologies%20(Pty)%20Ltd!5e0!3m2!1sen!2sin!4v1747914566030!5m2!1sen!2sin"
//footer data


export const COMPANY_INFO = {
    phoneHeading: " 24/7 CALL US",
    phone: "+(528) 456-7592",
    addressHeading: " 24/7 Our Location",
    address: "132, Tic St, Kingston, New York 12401, USA",
    newsletterMessage:
        "Welcome to Finxpert! Signup for our latest news & articles. We won’t send spam or irrelevant messages.",
};

export const SOCIAL_LINKS = [
    { href: "https://www.facebook.com", icon: "Facebook", label: "Facebook" },
    { href: "https://www.linkedin.com", icon: "LinkedIn", label: "LinkedIn" },
    { href: "https://www.twitter.com", icon: "XIcon", label: "Twitter" },
    { href: "https://www.instagram.com", icon: "Instagram", label: "Instagram" },
];

export const footerData = `Privacy Policy | Terms & Conditions | © ${new Date().getFullYear()} Company Name. All rights reserved.`